import { RootState } from '@store/redux.store'
import type { TaskTrackerState } from '../index'
import { createEmptyTaskDrawerState } from './taskDrawer.state.utils'

type AppState = RootState & {
  taskTracker: TaskTrackerState
}

export const selectTaskTrackerTaskDrawer = (state: AppState) =>
  state.taskTracker.taskDrawer ?? createEmptyTaskDrawerState()
